import React, { useState } from "react";
import { auth } from "../../services/firebase/config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useDispatch } from "react-redux";
import { setUser, setError, setLoading } from "../../store/slices/authSlice";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { initializeUserData } from "../../services/firebase/initializeData";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Modified to redirect to open house page instead of creating a user
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Temporarily redirect to open house page
    navigate("/open-house");
    
    // Original code is commented out for now
    /*
    dispatch(setLoading(true));
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      await initializeUserData(userCredential.user.uid, {
        email: userCredential.user.email,
        name: displayName,
        idNumber: "",
        address: "",
        neighborhoodDollars: 1000,
        photoURL: "",
        nfcCardId: "",
      });

      dispatch(
        setUser({
          uid: userCredential.user.uid,
          email: userCredential.user.email,
          displayName: displayName,
          photoURL: null,
          emailVerified: userCredential.user.emailVerified,
        })
      );

      navigate("/profile");
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
    */
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography component="h1" variant="h5" align="center">
          Sign Up
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="displayName"
            label="Display Name"
            name="displayName"
            autoComplete="name"
            autoFocus
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign Up
          </Button>
          <Link to="/signin" style={{ textDecoration: "none" }}>
            <Button fullWidth variant="text">
              Already have an account? Sign In
            </Button>
          </Link>
        </Box>
      </Paper>
    </Container>
  );
}

export default SignUp;
